import { render } from "./AccountDeleted.vue?vue&type=template&id=47a2f935"
import script from "./AccountDeleted.vue?vue&type=script&lang=js"
export * from "./AccountDeleted.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__